import request from '@/utils/request'

let DynamicApi = {

  /*动态列表*/
  list(data) {
    return request._post('/shop/plus.dynamic.Index/index', data);
},
/*添加动态*/
add(data) {
    return request._post('/shop/plus.dynamic.Index/add', data);
},
/*修改动态*/
edit(data) {
    return request._post('/shop/plus.dynamic.Index/edit', data);
},
/*删除动态*/
del(data) {
    return request._post('/shop/plus.dynamic.Index/del', data);
},
/*动态详情*/
detail(data) {
  return request._post('/shop/plus.dynamic.Index/detail', data);
},
 /*动态评论*/
 comment(data) {
  return request._post('/shop/plus.dynamic.Index/comment', data);
},
 /*删除评论*/
 delComment(data) {
  return request._post('/shop/plus.dynamic.Index/delComment', data);
},
passCanelE(data) {
  return request._post('/shop/plus.dynamic.Index/passComment', data);
},

}
export default DynamicApi;



// WEBPACK FOOTER //
// ./src/api/dynamic.js